export function appendHoneypotFields(formData) {
    document.querySelectorAll('.js-honeypot input').forEach((input) => {
        if (input.name) {
            formData.append(input.name, input.value);
        }
    });
}
